/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Conversation } from '../../models/conversation';
import { ConversationWithSearchCreationData } from '../../models/conversation-with-search-creation-data';

export interface ConversationStartConversationWithSearch$Params {
      body: ConversationWithSearchCreationData
}

export function conversationStartConversationWithSearch(http: HttpClient, rootUrl: string, params: ConversationStartConversationWithSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<Conversation>> {
  const rb = new RequestBuilder(rootUrl, conversationStartConversationWithSearch.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Conversation>;
    })
  );
}

conversationStartConversationWithSearch.PATH = '/conversation/search';
